import {CLEAR} from "./user";

export const ERROR = 'messages/ERROR'

const initialState = {
    error:''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ERROR:
            let nstate = {
                ...state,
                error:action.data
            };
            return nstate;
        case CLEAR:
            return initialState;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/modules/messages.js